var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 50,
    height: 32,
    x: 7,
    y: 24,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4877b1"
    },
    d: "M 7,44.5 C 7,45.885 8.115,47 9.5,47 H 54.5 C 55.885,47 57,45.885 57,44.5 V 17.5 C 57,16.115 55.885,15 54.5,15 H 29 V 12.5 C 29,11.115 27.885,10 26.5,10 H 9.5 C 8.115,10 7,11.115 7,12.5"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 0.2
    },
    width: 50,
    height: 32,
    x: 7,
    y: 22,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#e4e4e4"
    },
    width: 44,
    height: 20,
    x: 10,
    y: 18,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#5294e2"
    },
    width: 50,
    height: 32,
    x: 7,
    y: 23,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffffff"
    },
    d: "M 9.5,10 C 8.115,10 7,11.115 7,12.5 V 13.5 C 7,12.115 8.115,11 9.5,11 H 26.5 C 27.885,11 29,12.115 29,13.5 V 12.5 C 29,11.115 27.885,10 26.5,10 Z M 29,15 V 16 H 54.5 C 55.89,16 57,17.115 57,18.5 V 17.5 C 57,16.115 55.89,15 54.5,15 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1d344f"
    },
    d: "M 26.412,28 24.998,29.414 27.302,31.718 A 2.9989,2.9989 0 0 0 27.005,33.007 2.9989,2.9989 0 0 0 29.005,35.83 V 44.178 A 2.9989,2.9989 0 0 0 27.007,47 2.9989,2.9989 0 0 0 30.006,49.999 2.9989,2.9989 0 0 0 33.005,47 2.9989,2.9989 0 0 0 31.005,44.177 V 35.829 A 2.9989,2.9989 0 0 0 31.294,35.708 L 35.3,39.713 A 2.9989,2.9989 0 0 0 35.004,41.002 2.9989,2.9989 0 0 0 38.003,44.001 2.9989,2.9989 0 0 0 41.001,41.002 2.9989,2.9989 0 0 0 38.003,38.004 2.9989,2.9989 0 0 0 36.714,38.3 L 32.708,34.295 A 2.9989,2.9989 0 0 0 33.005,33.006 2.9989,2.9989 0 0 0 30.006,30.007 2.9989,2.9989 0 0 0 28.717,30.304 L 26.414,28.002 Z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommit);
export default __webpack_public_path__ + "static/media/commit.f64bb0a71b8cf347083d1dcb7bdcb475.svg";
export { ForwardRef as ReactComponent };